/*
 * js-jm-header.js — חיפוש חי, ניווט מקלדת והמגירה בנייד.
 *
 * למה לא /search/suggest.json
 * ---------------------------
 * ממשק ה-Predictive Search של שופיפיי נתמך רק ברשימת שפות סגורה, ועברית
 * אינה בה. על החנות החיה:
 *
 *   curl "https://i6qzve-zj.myshopify.com/search/suggest.json?q=iphone"
 *   → 417 {"description":"Unsupported buyer locale"}
 *
 * והתבנית עצמה מקבלת מהפלטפורמה "predictiveSearch":false בתוך
 * <script id="shopify-features">. לכן ההצעות נמשכות דרך Section Rendering
 * API, שהוא ממשק רשמי ועובד בכל שפה:
 *
 *   /search?q=<מילה>&type=product&section_id=jm-search-suggest
 *
 * התשובה היא HTML מוכן. הקובץ הזה לא בונה כרטיס מוצר ולא מרכיב מחיר —
 * המחיר מגיע מ-jm-price בצד השרת, עם תווית "ללא מע״מ" במקומה, וכל טקסט
 * מגיע מ-locales דרך הסינון t. סקריפט שמרכיב מחיר או מחרוזת עברית הוא
 * באג שמחכה לקרות.
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 260;
  var SUGGEST_CACHE = {};

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ------------------------------------------------------------------
     פריסת מקלדת שגויה — "ןפיםמק" במקום "iphone"
     ------------------------------------------------------------------

     המקלדת העברית יושבת על אותם מקשים פיזיים של QWERTY, ולכן מי ששכח
     להחליף שפה מקבל מיפוי 1:1 של תווים. שני הכיוונים שכיחים בישראל:
     גם ‎ןפיםמק‎ (הקלדת "iphone" כשהמקלדת בעברית) וגם ‎thhpui‎ (הקלדת
     "אייפון" כשהמקלדת באנגלית).

     למה לא פשוט "אם אין תוצאות — נסה למפות"
     ---------------------------------------
     כי בחנות הזאת אין "אין תוצאות". החיפוש של שופיפיי עושה התאמה
     מטושטשת ומחזיר זבל במקום אפס. נמדד על החנות החיה:

       ןפיםמק   → 35 תוצאות (Meta Quest 3S, משקפי מציאות מדומה)
       thhpui   → 77 תוצאות ("טאבלט סמסונג זול ואיכותי")
       גטדםמ    →  4 תוצאות (מגהץ אדים נורמנדה)
       דשצדומע  →  1 תוצאה

     כלומר הלקוח לא רואה "לא נמצא" אלא תוצאות שגויות, ומסיק שאין לנו
     את המוצר. וגם השוואת מספרי תוצאות לא עוזרת: ‎שואב‎ מחזיר 39 ואילו
     הג'יבריש ‎autc‎ מחזיר 127 — כלל כזה היה "מתקן" חיפוש תקין.

     לכן ההחלטה מתקבלת על המחרוזת עצמה, לפני השאילתה: ממפים לפריסה
     השנייה ובודקים מול מילון מילות הקטלוג (‎jm-search-lexicon.json‎).
     הכלל: אם מה שהוקלד כבר קיים בקטלוג — לא נוגעים. רק אם הוא לא
     קיים והגרסה הממופה כן, מחליפים. זה מה ששומר על ‎iphone‎, ‎dyson‎,
     ‎samsung‎, ‎שואב‎ ו-‎אייפון‎ בדיוק כמו שהוקלדו.

     ההשוואה היא לפי תחילית ולא לפי מילה שלמה, כי החלונית נפתחת אחרי
     שני תווים — באמצע ההקלדה. נמדד על 1,764 מילות הקטלוג, כשכל אחת
     "הוקלדה" בפריסה ההפוכה, על כל התחיליות שלה:

       התאמת תחילית:  5,749 / 6,116 = 94.0% זיהוי,  0 תקלות שווא
       מילה שלמה:     1,939 / 6,116 = 31.7% זיהוי,  6 תקלות שווא

     ריענון המילון: הוא נבנה מ-‎/products.json‎ ומ-‎/collections.json‎ —
     שמות, יצרנים, סוגי מוצר, תגיות ושמות אוספים, מילים באורך 3+.
     כשהקטלוג משתנה מהותית בונים אותו מחדש; ‎generated‎ בראש הקובץ הוא
     תאריך הבנייה. */

  var LEX_ASSET = 'jm-search-lexicon.json';

  /* פריסת המקלדת העברית התקנית על מקשי QWERTY. שתי המחרוזות מקבילות
     תו-מול-תו, ומכאן נבנים שני הכיוונים. */
  var KEYS_EN = "qwertyuiop[]asdfghjkl;'zxcvbnm,./";
  var KEYS_HE = "/'קראטוןםפ][שדגכעיחלךף,זסבהנמצתץ.";

  var Layout = (function () {
    var EN2HE = {};
    var HE2EN = {};
    for (var i = 0; i < KEYS_EN.length; i++) {
      EN2HE[KEYS_EN.charAt(i)] = KEYS_HE.charAt(i);
      if (HE2EN[KEYS_HE.charAt(i)] === undefined) HE2EN[KEYS_HE.charAt(i)] = KEYS_EN.charAt(i);
    }

    var HEBREW = /[֐-׿]/;
    var LATIN = /[A-Za-z]/;
    var SPLIT = /[^0-9A-Za-z֐-׿]+/;
    var MIN_TOKEN = 3;

    var tokens = null;   /* מערך ממוין; null = לא נטען, [] = נטען וריק */
    var promise = null;

    function remap(text, table) {
      var out = '';
      for (var i = 0; i < text.length; i++) {
        var c = text.charAt(i);
        out += table[c] !== undefined ? table[c] : c;
      }
      return out;
    }

    /* חיפוש בינארי על מערך ממוין: האם קיימת מילת קטלוג שמתחילה ב-term.
       הסדר שבו הקובץ נבנה הוא לפי נקודות קוד, וזה גם הסדר שבו ‎<‎ של
       JavaScript משווה מחרוזות בטווחים האלה — נבדק על כל 1,764 הערכים. */
    function hasPrefix(term) {
      if (!tokens || !tokens.length) return false;
      var lo = 0;
      var hi = tokens.length;
      while (lo < hi) {
        var mid = (lo + hi) >> 1;
        if (tokens[mid] < term) lo = mid + 1; else hi = mid;
      }
      return lo < tokens.length && tokens[lo].indexOf(term) === 0;
    }

    function wordsOf(text) {
      var parts = text.split(SPLIT);
      var out = [];
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].length >= MIN_TOKEN) out.push(parts[i]);
      }
      return out;
    }

    function anyKnown(text) {
      var words = wordsOf(text);
      for (var i = 0; i < words.length; i++) {
        if (hasPrefix(words[i])) return true;
      }
      return false;
    }

    /* מחזיר את המחרוזת המתוקנת, או null כשאין מה לתקן. */
    function correct(term) {
      if (!tokens || !tokens.length || !term) return null;
      var q = term.toLowerCase();
      var heb = HEBREW.test(q);
      var lat = LATIN.test(q);

      /* מחרוזת מעורבת כתבים היא בחירה של המשתמש ("מגן מסך iphone"),
         ומחרוזת בלי אותיות בכלל היא מק״ט. בשתיהן לא נוגעים. */
      if (heb === lat) return null;
      if (!wordsOf(q).length) return null;

      /* מה שהוקלד כבר מוכר לקטלוג — זו שאילתה תקינה. */
      if (anyKnown(q)) return null;

      var alt = remap(q, heb ? HE2EN : EN2HE);
      return anyKnown(alt) ? alt : null;
    }

    function load() {
      if (promise) return promise;
      var root = document.documentElement.getAttribute('data-jm-search-lexicon');
      if (!root) {
        tokens = [];
        promise = Promise.resolve();
        return promise;
      }
      promise = fetch(root)
        .then(function (response) {
          if (!response.ok) throw new Error('lexicon ' + response.status);
          return response.json();
        })
        .then(function (data) {
          tokens = data && data.tokens && data.tokens.length ? data.tokens : [];
        })
        .catch(function () {
          /* נפילה שקטה: החיפוש ממשיך לעבוד בדיוק כמו קודם. */
          tokens = [];
        });
      return promise;
    }

    return { load: load, correct: correct, remap: remap, en2he: EN2HE, he2en: HE2EN };
  })();

  /* ממלא את שני ה-‎<bdi>‎ שבתבנית ‎jm-search-layout-fix‎ ומחזיר את
     ההודעה המוכנה. כל טקסט קבוע בא מה-‎<template>‎, כלומר מ-locales. */
  function buildFixNote(scope, fixedTerm, typedTerm, onUndo, selector) {
    var tpl = qs(scope, selector || '[data-jm-search-fix-template]');
    if (!tpl || !tpl.content) return null;
    var node = tpl.content.firstElementChild.cloneNode(true);
    var fixedEl = qs(node, '[data-jm-search-fix-term]');
    var typedEl = qs(node, '[data-jm-search-fix-typed]');
    var undoEl = qs(node, '[data-jm-search-fix-undo]');
    if (fixedEl) fixedEl.textContent = fixedTerm;
    if (typedEl) typedEl.textContent = typedTerm;
    if (undoEl) {
      if (onUndo) {
        undoEl.addEventListener('click', onUndo);
      } else {
        undoEl.parentNode.removeChild(undoEl);
      }
    }
    return node;
  }

  /* ------------------------------------------------------------------
     חיפוש עם השלמה חיה
     ------------------------------------------------------------------ */

  function SearchForm(form) {
    this.form = form;
    this.input = qs(form, '[data-jm-search-input]');
    this.panel = qs(form, '[data-jm-search-panel]');
    this.slot = qs(form, '[data-jm-search-results]');
    this.status = qs(form, '[data-jm-search-status]');
    this.trend = qs(form, '[data-jm-search-trend]');
    this.clearBtn = qs(form, '[data-jm-search-clear]');
    this.placeholder = qs(form, '.search-header__placeholder');
    this.searchUrl = form.getAttribute('data-search-url') || '/search';
    this.sectionId = form.getAttribute('data-section-id') || 'jm-search-suggest';
    this.minChars = parseInt(form.getAttribute('data-min-chars'), 10) || 2;

    this.options = [];
    this.activeIndex = -1;
    this.controller = null;
    this.timer = null;
    this.requestVersion = 0;
    this.open = false;

    /* ‎forceExact‎ נדלק כשהלקוח לוחץ "חיפוש במקום זאת ל־…" — כלומר הוא
       באמת התכוון למה שהקליד. הוא כבה ברגע שממשיכים להקליד. */
    this.forceExact = false;

    if (!this.input || !this.panel || !this.slot) return;
    this.bind();
  }

  SearchForm.prototype.bind = function () {
    var self = this;

    this.input.addEventListener('input', function () {
      self.forceExact = false;
      self.toggleClear();
      self.schedule();
    });

    this.input.addEventListener('focus', function () {
      /* המילון נמשך רק מכאן — מי שלא נגע בחיפוש לא משלם עליו כלום. */
      Layout.load();
      if (self.input.value.trim().length >= self.minChars) {
        self.schedule(0);
      } else {
        self.setOpen(true);
      }
    });

    this.input.addEventListener('keydown', function (event) { self.onKeydown(event); });

    this.form.addEventListener('submit', function (event) { self.onSubmit(event); });

    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', function () {
        self.cancelPending();
        self.input.value = '';
        self.toggleClear();
        self.renderEmpty();
        self.input.focus();
      });
    }

    if (this.trend) {
      qsa(this.trend, '[data-jm-search-trend-item]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.input.value = (btn.textContent || '').trim();
          self.toggleClear();
          self.input.focus();
          self.schedule(0);
        });
      });
    }

    /* לחיצה מחוץ לטופס סוגרת. הקשבה על הלכידה כדי שקישור בתוך
       החלונית עדיין יספיק לנווט לפני הסגירה. */
    document.addEventListener('click', function (event) {
      if (self.form.contains(event.target)) return;
      self.setOpen(false);
    });

    this.toggleClear();
  };

  SearchForm.prototype.toggleClear = function () {
    var empty = this.input.value.trim().length === 0;

    if (this.clearBtn) this.clearBtn.classList.toggle('hide', empty);

    /* ה-placeholder המונפש הוא שכבה נפרדת מעל השדה, לא תכונת
       placeholder אמיתית, ולכן הוא נשאר גלוי מעל מה שהוקלד. ה-CSS
       מסתיר אותו במיקוד בלבד; מחוץ למיקוד צריך להסתירו לפי תוכן.
       סגנון inline ולא מחלקה, כי הכלל שמולו עומדים הוא ‎!important‎. */
    if (this.placeholder) this.placeholder.style.display = empty ? '' : 'none';
  };

  /* Invalidate work immediately, including responses whose fetch has already
     resolved. Abort alone cannot stop a queued response from reopening a panel. */
  SearchForm.prototype.cancelPending = function () {
    window.clearTimeout(this.timer);
    this.timer = null;
    this.requestVersion += 1;
    if (this.controller) this.controller.abort();
    this.controller = null;
    this.form.classList.remove('jm-search-loading');
  };

  SearchForm.prototype.schedule = function (delay) {
    var self = this;
    this.cancelPending();
    this.timer = window.setTimeout(function () { self.request(); }, typeof delay === 'number' ? delay : DEBOUNCE_MS);
  };

  SearchForm.prototype.suggestUrl = function (term) {
    return this.searchUrl +
      '?q=' + encodeURIComponent(term) +
      '&type=product' +
      '&section_id=' + encodeURIComponent(this.sectionId);
  };

  SearchForm.prototype.request = function () {
    var self = this;
    var typed = this.input.value.trim();
    this.cancelPending();
    var version = this.requestVersion;

    if (typed.length < this.minChars) {
      this.renderEmpty();
      this.setOpen(true);
      return;
    }

    /* ההמתנה למילון היא microtask אחת מהרגע שהוא נטען, ופתיחת השדה
       מקדימה את ההקלדה — כך שבפועל הוא כאן לפני התו השני. */
    Layout.load().then(function () {
      if (version !== self.requestVersion || self.input.value.trim() !== typed) return;
      self.fetchSuggest(typed, version);
    });
  };

  SearchForm.prototype.fetchSuggest = function (typed, version) {
    var self = this;
    var fixed = this.forceExact ? null : Layout.correct(typed);
    var term = fixed || typed;

    if (SUGGEST_CACHE[term] !== undefined) {
      this.render(SUGGEST_CACHE[term], fixed, typed);
      return;
    }

    this.controller = 'AbortController' in window ? new AbortController() : null;

    this.form.classList.add('jm-search-loading');

    fetch(this.suggestUrl(term), this.controller ? { signal: this.controller.signal } : undefined)
      .then(function (response) {
        if (!response.ok) throw new Error('suggest ' + response.status);
        return response.text();
      })
      .then(function (html) {
        SUGGEST_CACHE[term] = html;
        if (version !== self.requestVersion || self.input.value.trim() !== typed) return;
        self.render(html, fixed, typed);
      })
      .catch(function (error) {
        if (version !== self.requestVersion || (error && error.name === 'AbortError')) return;
        /* נפילה שקטה: החלונית נסגרת, והטופס עדיין נשלח כרגיל. */
        self.renderEmpty();
      })
      .then(function () {
        if (version === self.requestVersion) self.form.classList.remove('jm-search-loading');
      });
  };

  SearchForm.prototype.render = function (html, fixed, typed) {
    var self = this;
    this.slot.innerHTML = html;
    this.slot.hidden = false;
    if (this.trend) this.trend.hidden = true;

    /* ההודעה נכנסת לפני התוצאות, כי היא מסבירה מה הן. הכפתור שבתוכה
       מחזיר את הלקוח למה שהוא באמת הקליד, ואז ‎forceExact‎ מונע תיקון
       חוזר על אותה מחרוזת. */
    if (fixed) {
      var note = buildFixNote(this.form, fixed, typed, function () {
        self.forceExact = true;
        self.request();
        self.input.focus();
      });
      if (note) this.slot.insertBefore(note, this.slot.firstChild);
    }

    /* המקטע מרונדר את אותם מזהי אפשרות בכל מופע של הטופס, ובעמוד יש
       שלושה. ‎aria-activedescendant‎ מצביע על ‎id‎ — ושני אלמנטים עם
       אותו ‎id‎ פירושם הכרזה על האלמנט הלא נכון. מזהה ייחודי לכל טופס. */
    this.options = qsa(this.slot, '[data-jm-suggest-option]');
    var prefix = this.input.id || 'jm-search';
    this.options.forEach(function (option, index) {
      option.id = prefix + '-option-' + (index + 1);
    });

    this.activeIndex = -1;
    this.input.removeAttribute('aria-activedescendant');

    var message = qs(this.slot, '[data-jm-suggest-message]');
    if (this.status) this.status.textContent = message ? (message.textContent || '').trim() : '';

    this.options.forEach(function (option, index) {
      option.addEventListener('mousemove', function () { self.setActive(index, false); });
    });

    this.setOpen(true);
  };

  SearchForm.prototype.renderEmpty = function () {
    this.slot.innerHTML = '';
    this.slot.hidden = true;
    if (this.trend) this.trend.hidden = false;
    this.options = [];
    this.activeIndex = -1;
    this.input.removeAttribute('aria-activedescendant');
    if (this.status) this.status.textContent = '';
  };

  SearchForm.prototype.setOpen = function (open) {
    this.open = open;
    this.panel.classList.toggle('jm-search-panel--open', open);
    this.input.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) {
      this.cancelPending();
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
      this.options.forEach(function (option) { option.setAttribute('aria-selected', 'false'); });
    }
  };

  SearchForm.prototype.setActive = function (index, scroll) {
    this.activeIndex = index;
    this.options.forEach(function (option, i) {
      var active = i === index;
      option.setAttribute('aria-selected', active ? 'true' : 'false');
      option.classList.toggle('is-active', active);
    });

    if (index < 0) {
      this.input.removeAttribute('aria-activedescendant');
      return;
    }

    var current = this.options[index];
    this.input.setAttribute('aria-activedescendant', current.id);
    if (scroll && current.scrollIntoView) current.scrollIntoView({ block: 'nearest' });
  };

  SearchForm.prototype.onKeydown = function (event) {
    var count = this.options.length;

    if (event.key === 'Escape') {
      if (this.open) {
        event.preventDefault();
      }
      this.setOpen(false);
      return;
    }

    if (event.key === 'Tab') {
      this.setOpen(false);
      return;
    }

    if (event.key === 'Enter') {
      if (this.activeIndex > -1 && this.options[this.activeIndex]) {
        event.preventDefault();
        var url = this.options[this.activeIndex].getAttribute('data-url');
        if (url) window.location.href = url;
      }
      return;
    }

    var arrowKey = event.key === 'ArrowDown' || event.key === 'ArrowUp';
    if (!count) {
      if (arrowKey && this.input.value.trim().length >= this.minChars) {
        event.preventDefault();
        this.schedule(0);
      }
      return;
    }
    if (!this.open) {
      if (!arrowKey) return;
      this.setOpen(true);
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.setActive(this.activeIndex + 1 >= count ? 0 : this.activeIndex + 1, true);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.setActive(this.activeIndex - 1 < 0 ? count - 1 : this.activeIndex - 1, true);
    } else if (event.key === 'Home') {
      event.preventDefault();
      this.setActive(0, true);
    } else if (event.key === 'End') {
      event.preventDefault();
      this.setActive(count - 1, true);
    }
  };

  /* שליחה מצומצמת למחלקה: כשנבחרה מחלקה בבורר, החיפוש מתבצע בתוך
     האוסף. ההתנהגות הזו הייתה ב-js-global וקשורה ל-form[action="search"];
     מאחר שה-action עבר לנתיב האמיתי, היא נבנית כאן מחדש. */
  SearchForm.prototype.onSubmit = function (event) {
    var selected = qs(this.form, '.search-category__selected');
    var handle = selected ? (selected.getAttribute('data-value') || '') : '';
    var typed = this.input.value.trim();
    var fixed = this.forceExact ? null : Layout.correct(typed);

    /* אין מחלקה ואין תיקון — שליחה רגילה של הטופס, בלי שכבת JavaScript. */
    if (!handle && !fixed) return;

    event.preventDefault();
    var term = fixed || typed;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    root = root.replace(/\/$/, '');

    var url;
    if (handle) {
      /* חיפוש בתוך מחלקה. עמוד האוסף לא מציג את הודעת התיקון, ולכן
         ‎jm_typed‎ לא נוסף כאן — הוא היה פרמטר מת בכתובת. */
      url = root + '/collections/' + encodeURIComponent(handle);
      if (term) url += '?q=' + encodeURIComponent(term);
    } else {
      /* ‎jm_typed‎ הוא מה שהלקוח הקליד בפועל. עמוד התוצאות קורא אותו
         ומציג ממנו את ההודעה ואת הדרך חזרה. */
      url = (this.searchUrl || root + '/search') +
        '?type=product&q=' + encodeURIComponent(term) +
        '&jm_typed=' + encodeURIComponent(typed);
    }
    window.location.href = url;
  };

  /* ------------------------------------------------------------------
     חיפוש קולי — he-IL
     ------------------------------------------------------------------ */

  function bindVoice(form) {
    var button = qs(form, '[data-jm-search-mic]');
    var input = qs(form, '[data-jm-search-input]');
    var Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!button) return;
    if (!Recognition) { button.hidden = true; return; }

    var recognition = null;

    button.addEventListener('click', function () {
      if (recognition) { recognition.stop(); return; }

      recognition = new Recognition();
      recognition.lang = document.documentElement.lang || 'he-IL';
      if (recognition.lang.indexOf('-') === -1) recognition.lang = recognition.lang + '-IL';
      recognition.interimResults = true;
      recognition.continuous = false;
      recognition.maxAlternatives = 1;

      recognition.onstart = function () {
        button.classList.add('is-listening');
        button.setAttribute('aria-pressed', 'true');
      };
      recognition.onresult = function (event) {
        var text = '';
        for (var i = 0; i < event.results.length; i++) text += event.results[i][0].transcript;
        input.value = text;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      };
      recognition.onend = function () {
        button.classList.remove('is-listening');
        button.setAttribute('aria-pressed', 'false');
        recognition = null;
        input.focus();
      };
      recognition.start();
    });
  }

  /* ------------------------------------------------------------------
     בורר המחלקות — הפעלה במקלדת ומצב aria
     ------------------------------------------------------------------ */

  function bindCategory(form) {
    var select = qs(form, '.search-category__select');
    if (!select) return;

    var observer = new MutationObserver(function () {
      select.setAttribute('aria-expanded', select.classList.contains('open') ? 'true' : 'false');
    });
    observer.observe(select, { attributes: true, attributeFilter: ['class'] });
  }

  /* ------------------------------------------------------------------
     המגירה בנייד: Escape, מלכודת פוקוס, החזרת פוקוס, מצב aria
     ------------------------------------------------------------------ */

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function visible(element) {
    if (element.closest('[inert], [aria-hidden="true"]')) return false;
    if (window.getComputedStyle) {
      var style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function setInactive(element, inactive) {
    if (!element) return;
    element.toggleAttribute('inert', inactive);
    element.setAttribute('aria-hidden', inactive ? 'true' : 'false');
  }

  function focusElement(element) {
    if (!element || !element.isConnected) return;
    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function initDrawer() {
    var drawer = document.getElementById('mobile_menu');
    var toggle = document.getElementById('show-megamenu');
    var toggles = qsa(document, '#show-megamenu, .jm-tablet-menu-toggle');
    var overlay = document.querySelector('.sidebar-overlay');
    if (!drawer || !toggle) return;

    var lastFocus = null;
    var wasOpen = false;
    var desktop = window.matchMedia ? window.matchMedia('(min-width: 1200px)') : null;

    function isOpen() { return drawer.classList.contains('act'); }

    function controlledPanel(control) {
      var id = control && control.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    function controllerFor(panel) {
      if (!panel || !panel.id) return null;
      return qsa(drawer, '[aria-controls]').filter(function (control) {
        return control.getAttribute('aria-controls') === panel.id;
      })[0] || null;
    }

    function resetNestedNavigation() {
      qsa(drawer, '.direc1.act, .direc2.act').forEach(function (control) {
        control.classList.remove('act');
      });
    }

    function syncNestedNavigation() {
      var open = isOpen();
      var levelOneTriggers = qsa(drawer, '.direc1');
      var activeLevelOne = levelOneTriggers.filter(function (control) {
        return control.classList.contains('act');
      })[0] || null;
      var activeLevelOnePanel = controlledPanel(activeLevelOne);

      /* A level-two state cannot survive after its parent was closed. Apart
         from confusing the next open, it would expose the third layer while
         its parent trigger still announces collapsed. */
      qsa(drawer, '.direc2.act').forEach(function (control) {
        if (!activeLevelOnePanel || !activeLevelOnePanel.contains(control)) {
          control.classList.remove('act');
        }
      });

      var rootInactive = !open || !!activeLevelOne;
      qsa(drawer, '.site-nav-mobile > .nav--lv1 > .jm-nav-row, .site-nav-mobile > .nav--lv1 > .site-nav__link--main').forEach(function (row) {
        setInactive(row, rootInactive);
      });

      levelOneTriggers.forEach(function (control) {
        var expanded = open && control === activeLevelOne;
        var panel = controlledPanel(control);
        control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        setInactive(panel, !expanded);
      });

      qsa(drawer, '.nav-xs-lv1').forEach(function (levelOnePanel) {
        var levelOneOpen = open && levelOnePanel === activeLevelOnePanel;
        var levelTwoTriggers = qsa(levelOnePanel, '.direc2');
        var activeLevelTwo = levelTwoTriggers.filter(function (control) {
          return levelOneOpen && control.classList.contains('act');
        })[0] || null;
        var activeLevelTwoPanel = controlledPanel(activeLevelTwo);
        var covered = !!activeLevelTwo;

        var levelOneBack = qs(levelOnePanel, ':scope > .navbar');
        setInactive(levelOneBack, !levelOneOpen || covered);
        qsa(levelOnePanel, '.jm-nav-row-2').forEach(function (row) {
          setInactive(row, !levelOneOpen || covered);
        });

        levelTwoTriggers.forEach(function (control) {
          var expanded = levelOneOpen && control === activeLevelTwo;
          control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          setInactive(controlledPanel(control), !expanded);
        });

        qsa(levelOnePanel, '.nav-xs-lv2').forEach(function (panel) {
          if (panel !== activeLevelTwoPanel) setInactive(panel, true);
        });
      });
    }

    function restoreOpener() {
      if (lastFocus && document.contains(lastFocus)) focusElement(lastFocus);
      lastFocus = null;
    }

    function syncDrawer(moveFocus) {
      var open = isOpen() && !(desktop && desktop.matches);

      if (!open && isOpen()) {
        drawer.classList.remove('act');
        toggles.forEach(function (trigger) { trigger.classList.remove('act'); });
        if (overlay) overlay.classList.remove('act');
      }

      drawer.toggleAttribute('inert', !open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      drawer.setAttribute('aria-modal', open ? 'true' : 'false');
      document.body.classList.toggle('jm-mobile-menu-open', open);
      toggles.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      if (!open) resetNestedNavigation();
      syncNestedNavigation();

      if (open && !wasOpen && moveFocus) {
        focusElement(qs(drawer, '[data-jm-drawer-close]') || drawer);
      } else if (!open && wasOpen) {
        restoreOpener();
      }
      wasOpen = open;
    }

    function close() {
      /* הסגירה עצמה שייכת ל-js-global: שכבת הכיסוי היא שמנקה את כל
         המצבים הפתוחים בבת אחת. כאן רק מפעילים אותה. */
      if (overlay && overlay.classList.contains('act')) {
        overlay.click();
      } else {
        var activeToggle = toggles.filter(function (trigger) { return trigger.classList.contains('act'); })[0];
        (activeToggle || toggle).click();
      }
    }

    // The vendor owns the visual class hooks. This layer owns focus and ARIA.
    toggles.forEach(function (trigger) {
      trigger.addEventListener('pointerdown', function () { lastFocus = trigger; });
      trigger.addEventListener('mousedown', function () { lastFocus = trigger; });
      trigger.addEventListener('click', function () { lastFocus = trigger; });
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') lastFocus = trigger;
      });
    });

    drawer.addEventListener('click', function (event) {
      var forward = event.target.closest('.direc1, .direc2');
      if (forward && drawer.contains(forward)) {
        window.setTimeout(function () {
          syncNestedNavigation();
          var panel = controlledPanel(forward);
          var back = panel && qs(panel, forward.classList.contains('direc1') ? '.direcback1' : '.direcback2');
          focusElement(back || panel);
        }, 0);
        return;
      }

      var back = event.target.closest('.direcback1, .direcback2');
      if (!back || !drawer.contains(back)) return;
      var panel = back.closest(back.classList.contains('direcback2') ? '.nav-xs-lv2' : '.nav-xs-lv1');
      var returnTarget = controllerFor(panel);
      if (back.classList.contains('direcback1') && panel) {
        qsa(panel, '.direc2.act').forEach(function (control) { control.classList.remove('act'); });
      }
      window.setTimeout(function () {
        syncNestedNavigation();
        focusElement(returnTarget);
      }, 0);
    });

    document.addEventListener('keydown', function (event) {
      if (!isOpen() || event.defaultPrevented) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        var activeLevelTwo = qs(drawer, '.direc2.act');
        if (activeLevelTwo) {
          var levelTwoPanel = controlledPanel(activeLevelTwo);
          var levelTwoBack = levelTwoPanel && qs(levelTwoPanel, '.direcback2');
          if (levelTwoBack) levelTwoBack.click();
          return;
        }
        var activeLevelOne = qs(drawer, '.direc1.act');
        if (activeLevelOne) {
          var levelOnePanel = controlledPanel(activeLevelOne);
          var levelOneBack = levelOnePanel && qs(levelOnePanel, '.direcback1');
          if (levelOneBack) levelOneBack.click();
          return;
        }
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      var items = qsa(drawer, FOCUSABLE).filter(visible);
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!drawer.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    });

    qsa(drawer, '[data-jm-drawer-close]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        close();
      });
    });

    var observer = new MutationObserver(function () {
      syncDrawer(true);
    });
    observer.observe(drawer, { subtree: true, attributes: true, attributeFilter: ['class'] });

    function onDesktopChange() {
      if (desktop && desktop.matches && isOpen()) close();
      window.setTimeout(function () { syncDrawer(false); }, 0);
    }
    if (desktop) {
      if (desktop.addEventListener) desktop.addEventListener('change', onDesktopChange);
      else if (desktop.addListener) desktop.addListener(onDesktopChange);
    }

    syncDrawer(false);
  }

  /* ------------------------------------------------------------------
     עמוד התוצאות המלא
     ------------------------------------------------------------------

     שני מצבים, ורק שניים:

     1. הגענו לכאן מהטופס והכתובת נושאת ‎jm_typed‎ — מציגים את ההודעה
        עם הדרך חזרה לשאילתה המקורית.

     2. הגענו ישירות לכתובת (היסטוריה, סימנייה, או טופס ההתאוששות
        שבתוך העמוד), אין תוצאות בכלל, ויש תיקון — אז מחליפים את
        הכתובת. ‎location.replace‎ ולא ‎href‎, כדי שכפתור "חזור" לא ייתקע
        בלופ בין שתי הכתובות.

     מה שבמתכוון לא קורה: עמוד שכן החזיר מוצרים לא מוחלף מתחת לידיים
     של הלקוח, גם אם השאילתה נראית כמו פריסה שגויה. החלפת עמוד שהציג
     תוצאות היא הפתעה, וההודעה לבדה שווה פחות מהנזק. */

  function initSearchPage() {
    var root = document.querySelector('[data-jm-search-page]');
    if (!root) return;

    var mount = qs(root, '[data-jm-search-fix-mount]');
    var params = new URLSearchParams(window.location.search);
    var query = (params.get('q') || '').trim();
    var typed = (params.get('jm_typed') || '').trim();
    var searchUrl = root.getAttribute('data-search-url') || '/search';

    function pageUrl(term, exact) {
      var url = searchUrl + '?type=product&q=' + encodeURIComponent(term);
      if (exact) url += '&jm_exact=1';
      return url;
    }

    bindPageForm(root, searchUrl);

    if (typed && typed !== query) {
      if (!mount) return;
      var note = buildFixNote(root, query, typed, function () {
        window.location.href = pageUrl(typed, true);
      });
      if (note) mount.appendChild(note);
      return;
    }

    if (params.get('jm_exact') || !query) return;

    Layout.load().then(function () {
      var fixed = Layout.correct(query);
      if (!fixed) return;

      /* עמוד ריק — אין מה לאבד, מחליפים אותו ישר בתוצאות הנכונות. */
      if (root.getAttribute('data-results-count') === '0') {
        window.location.replace(pageUrl(fixed) + '&jm_typed=' + encodeURIComponent(query));
        return;
      }

      /* עמוד שכבר מציג מוצרים לא מוחלף — מציעים בלבד. זה המצב של מי
         שהגיע מהיסטוריה או מקישור ששותף, כי שני הטפסים כבר מתקנים
         לפני הניווט. */
      if (!mount) return;
      var offer = buildFixNote(root, fixed, '', null, '[data-jm-search-fix-offer-template]');
      if (!offer) return;
      var link = qs(offer, '[data-jm-search-fix-go]');
      if (link) link.setAttribute('href', pageUrl(fixed) + '&jm_typed=' + encodeURIComponent(query));
      mount.appendChild(offer);
    });
  }

  /* טופס ההתאוששות שבתוך העמוד הוא ‎<form>‎ רגיל בלי ‎data-jm-search‎,
     ולכן התיקון לא עובר בו דרך ‎SearchForm‎. בלי הקישור הזה מי שמקליד
     בו בפריסה שגויה מקבל את אותו זבל מטושטש בלי שום הסבר — כי שאילתה
     כזאת בדרך כלל לא מחזירה אפס תוצאות, אלא תוצאות לא נכונות, ולכן
     גם שער ה-‎data-results-count‎ שלמעלה לא נסגר עליה. */
  function bindPageForm(root, searchUrl) {
    qsa(root, 'form').forEach(function (form) {
      var field = qs(form, 'input[name="q"]');
      if (!field || field.type === 'hidden') return;

      form.addEventListener('submit', function (event) {
        var typed = field.value.trim();
        var fixed = Layout.correct(typed);
        if (!fixed) return;
        event.preventDefault();
        window.location.href = searchUrl +
          '?type=product&q=' + encodeURIComponent(fixed) +
          '&jm_typed=' + encodeURIComponent(typed);
      });

      /* המילון נמשך ברגע שנוגעים בשדה, כדי שהוא יהיה שם בשליחה. */
      field.addEventListener('focus', function () { Layout.load(); });
    });
  }

  /* ------------------------------------------------------------------ */

  function init() {
    qsa(document, '[data-jm-search]').forEach(function (form) {
      new SearchForm(form);
      bindVoice(form);
      bindCategory(form);
    });
    initDrawer();
    initSearchPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
